module.exports = ["mobile/pricing"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/hk/zh_cn/pages.json
// module id = 610
// module chunks = 0 1 2 3 4 5